import React, { useState, useEffect, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { registrationTrackingEvent } from '../../../utilities/analytics';
import styles from './upgrade_to_ca_pitch.module.scss';
import MembershipFlowContext from '../../context/membership_flow_context';
import { createQueryString } from '../../../utilities/utilities';
import { CA_PACKAGE_SHORT_NAME } from '../../constants/membership_flow.constants';

const UpgradeToCaPitch = () => {
  const { paymentPage, returnTo } = useContext(MembershipFlowContext);
  const [goToNewsletters, setGoToNewsletters] = useState<boolean>(false);
  const [goToUpgradeFlow, setGoToUpgradeFlow] = useState<boolean>(false);

  // Track user registration in Plausible if it has not been tracked yet
  useEffect(() => {
    registrationTrackingEvent();
  }, []);

  if (goToNewsletters) {
    const nextStepPath = window.location.pathname.replace('upgrade-to-ca', 'newsletters');
    return <Redirect push to={nextStepPath} />;
  }

  if (goToUpgradeFlow) {
    const redirectionUrl =
      '/upgrade/payment' +
      createQueryString({
        package_short_name: CA_PACKAGE_SHORT_NAME,
        payment_page_permalink: paymentPage,
        return_to: returnTo
      });

    window.location.href = redirectionUrl;
  }

  return (
    <div className={styles.upgradeToCaPitch}>
      <h2 className={`${styles.title}  devex-font-family-serif`}>
        Looking for a new development job?
      </h2>
      <h4 className='text-gray fw-bold my-35'>
        Upgrade your membership to a Devex Career Account and get:
      </h4>
      <ul className='fs-6 text-gray-li mb-4'>
        <li className='mb-28 mb-md-2'>
          <i className={`me-2 fs-7 fal fw-bold icon-check-circle ${styles.blueCheckCircle}`} />
          Full access to the world’s largest development job board
        </li>
        <li className='mb-28 mb-md-2'>
          <i className={`me-2 fs-7 fal fw-bold icon-check-circle ${styles.blueCheckCircle}`} />
          Invitations to online career events
        </li>
        <li className='mb-28 mb-md-2'>
          <i className={`me-2 fs-7 fal fw-bold icon-check-circle ${styles.blueCheckCircle}`} />
          Featured Devex profile to stand out to recruiters
        </li>
        <li className='mb-28 mb-md-2'>
          <i className={`me-2 fs-7 fal fw-bold icon-check-circle ${styles.blueCheckCircle}`} />
          Practical insights and professional development advice to advance your career
        </li>
        <li className='mb-28 mb-md-2'>
          <i className={`me-2 fs-7 fal fw-bold icon-check-circle ${styles.blueCheckCircle}`} />
          <span>A</span>
          <strong className={styles.discount}> 60% discount</strong>
          <span> - only available to you now as a new member</span>
        </li>
      </ul>
      <p className='text-gray mb-45 fs-6'>Ready to upgrade and receive your discount?</p>
      <div className='text-center mt-md-5'>
        <button
          className={
            `btn btn-outline-secondary btn-lg me-0 my-3 my-md-0 me-md-3 ${styles.ctaButtons}`
          }
          onClick={() => setGoToNewsletters(true)}
        >
          <span>Not now</span>
        </button>
        <button
          className={`btn btn-dark btn-lg ${styles.ctaButtons}`}
          onClick={() => setGoToUpgradeFlow(true)}>
          <strong>Upgrade now</strong>
        </button>
      </div>
    </div>
  );
};

export default UpgradeToCaPitch;
